export default __webpack_public_path__ + "static/media/accounts.46029e91.svg";